<template>
  <div class='product-hdzb product-container product-strength-count-6'>
    <banner :data='banner'></banner>
    <div class='product-content'>
      <div class='section'>
        <strength :ourstrengths='strength'></strength>
      </div>
      <div class='section'>
        <use-case :usecase="scene"></use-case>
      </div>
      <div class='section'>
        <why-choose></why-choose>
      </div>
      <div class='section'>
        <price></price>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '../../components/banner.vue';
import Strength from '../../components/solution/our_strengths.vue';
import UseCase from '../../components/solution/use_case.vue';
import WhyChoose from '../../components/solution/why_choose.vue';
import { CONSOLE_SITE_URL } from '../../utils/constants';
import Price from './components/price.vue';

export default {
  metaInfo: {
    title: '实时互动直播-视频直播SDK-马兰头医学科技',
    meta: [
      {
        name: 'keywords',
        content: '互动直播,直播白板,会议直播,直播连麦,视频直播，直播SDK'
      },
      {
        name: 'description',
        content: '马兰头医学科技互动直播功能，支持百人连麦、百万人在线实时互动，凭借千万级别在线并发能力与全球内容分发网络，实现真正的低延迟“实时互动直播”'
      },
    ]
  },
  components: {
    Banner,
    Strength,
    UseCase,
    WhyChoose,
    Price,
  },
  data() {
    return {
      banner: {
        title: '互动直播',
        desc: '凭借千万级别在线并发能力与全球内容分发网络，实现真正的“实时互动直播”',
        image: require('../../assets/product/04.png'),
        buttonText: '立即体验',
        buttonCallback: () => {
          window.open(CONSOLE_SITE_URL);
        }
      },
      strength: {
        title: '几大优势，引爆直播间',
        content: [{
            title: '实时连麦互动',
            intro: '实时连麦互动，多个主播/观众可自由上下麦，连麦过程更精彩。切换过程无需等待',
            img: require('@/assets/product/46.png')
          },{
            title: '大并发互动',
            intro: '支持百人连麦、百万人在线实时互动，轻松应对在线人数激增',
            img: require('@/assets/product/47.png')
          },{
            title: '直播分发',
            intro: '提供直播分发服务，可实现 HLS、RTMP、HTTP 等多种直播分发形式',
            img: require('@/assets/product/48.png')
          },{
            title: '直播白板',
            intro: '直播白板功能，方便主播与用户之间进行互动答疑，提高互动性',
            img: require('@/assets/product/49.png')
          },{
            title: '全终端适配',
            intro: '适配市面主流平台。针对移动端进行直播优化，占用更少内存',
            img: require('@/assets/product/50.png')
          },{
            title: '超高清音画',
            intro: '从360P到1080P清晰度，可自主切换选择',
            img: require('@/assets/product/51.png')
          },
        ]
      },
      scene: {
        title: '使用场景',
        content: [{
            title: '电商直播',
            subtitle: '直播带货模式，支持亿万级大并发',
            img: require('@/assets/product/74.png')
          }, {
            title: '娱乐连麦',
            subtitle: '游戏、娱乐社交等场景下主播连麦PK，百万人同时在线互动',
            img: require('@/assets/product/75.png')
          }, {
            title: '手术直播',
            subtitle: '极限4K高清晰度支持，实现广播级“手术直播”需求',
            img: require('@/assets/product/76.png')
          }, {
            title: '会议直播',
            subtitle: '举手、发言、讨论等多种互动形式，让线上会议更生动',
            img: require('@/assets/product/77.png')
          }
        ]
      }
    }
  },
}
</script>

<style lang="less" scoped>
</style>